import axios from '@/axiosInterceptor';

const state = () => ({
  savedContacts: {
    dispatch: null,
    billing: null,
    claims: null,
    after_hours: null,
    emergency: null,
    owner: null,
  },
  contactIsTypes: [
    'dispatch',
    'billing',
    'claims',
    'after_hours',
    'emergency',
    'owner',
  ],
  requiredContactIsTypes: ['dispatch', 'billing', 'claims'],
  errors: {
    name: false,
    phone: false,
    email: false,
  },
  requiredContactsCompleted: false,
});

// getters
const getters = {};

// actions
const actions = {
  // async createContactByType({ commit }, data) {
  //   let body = {
  //     "contact": data
  //   }
  //   // let formData = new FormData();
  //   // formData.append('dispatcher_connection[carrier_id]', body.carrier_id);
  //   try {
  //       let res = await axios.post(process.env.API_MONITOR + "/api/v1/contacts", body)
  //       if (res && res?.data) {
  //         commit("setSavedContactByType", { data: res?.data, is_type: res?.data?.is_type })
  //       }
  //       return res;
  //   } catch (e) {
  //       let status = e.response?.status
  //       if (axios.isAxiosError(e) && status && [401, 403, 404, 422].includes(status)) {
  //           return e.response
  //       } else {
  //           throw e
  //       }
  //   }
  // },

  // Set all contacts from initial Identity contact values based on is_type
  async initializeContacts({ dispatch, state, commit }, data) {
    let allContacts = data?.contacts;
    let allEmails = data?.emails;
    let allPhones = data?.phones;

    state.contactIsTypes.forEach((t) => {
      let filtered = allContacts.filter(function (el) {
        return el.is_type == t;
      });
      let contact = filtered[0];
      if (contact) {
        if (!contact?.email_address) {
          let filteredEmails = allEmails.filter((el) => el.is_type === t);
          if (filteredEmails?.length > 0) {
            contact['email_address'] = filteredEmails[0];
          }
        }
        if (!contact?.phone) {
          let filteredPhones = allPhones.filter((el) => el.is_type === t);
          if (filteredPhones?.length > 0) {
            contact['phone'] = filteredPhones[0];
          }
        }
        commit('setSavedContact', { data: contact, is_type: t });
      }
    });
    dispatch('checkRequiredComplete');
  },

  async checkRequiredComplete({ state, commit }) {
    if (
      state.savedContacts?.dispatch &&
      state.savedContacts?.billing &&
      state.savedContacts?.claims
    ) {
      commit('setRequiredContactsCompleted', true);
    }
  },

  async createOrUpdateContact({ dispatch, commit }, data) {
    let method = data?.method;
    let payload = data?.payload;
    let body = {
      contact: payload,
    };

    // console.log('payload');
    // console.dir(payload);

    switch (method) {
      case 'post':
        try {
          let res = await axios.post(
            process.env.API_MONITOR + '/api/v1/contacts/',
            body
          );
          if (res && res?.data) {
            commit('setSavedContact', {
              data: res?.data,
              is_type: res?.data?.is_type,
            });
          }
          dispatch('checkRequiredComplete');
          return res;
        } catch (e) {
          let status = e?.response?.status;
          if (
            axios.isAxiosError(e) &&
            status &&
            [401, 403, 404, 422].includes(status)
          ) {
            return e?.response;
          } else {
            throw e;
          }
        }
      case 'patch':
        try {
          let res = await axios.patch(
            process.env.API_MONITOR + '/api/v1/contacts/' + payload['id'],
            body
          );
          if (res && res?.data) {
            commit('setSavedContact', {
              data: res?.data,
              is_type: res?.data?.is_type,
            });
          }
          return res;
        } catch (e) {
          let status = e?.response?.status;
          if (
            axios.isAxiosError(e) &&
            status &&
            [401, 403, 404, 422].includes(status)
          ) {
            return e?.response;
          } else {
            throw e;
          }
        }
    }
  },
  async removeSavedContactByType({ state, commit }, type) {
    commit('deleteSavedContactByType', type);
    if (state.requiredContactIsTypes.includes(type)) {
      commit('setRequiredContactsCompleted', false);
    }
  },
  async deleteContactById(_, id) {
    try {
      let res = await axios.delete(
        process.env.API_MONITOR + '/api/v1/contacts/' + id
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e?.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setSavedContact(state, { data, is_type }) {
    switch (is_type) {
      case 'dispatch':
        state.savedContacts.dispatch = data;
        break;
      case 'billing':
        state.savedContacts.billing = data;
        break;
      case 'claims':
        state.savedContacts.claims = data;
        break;
      case 'after_hours':
        state.savedContacts.after_hours = data;
        break;
      case 'emergency':
        state.savedContacts.emergency = data;
        break;
      case 'owner':
        state.savedContacts.owner = data;
        break;
    }
    // if (state.contacts[is_type]?.length > 0) {
    //     let matches = [ ...state.contacts[is_type] ];
    //     if (matches) {
    //         matches = matches.filter((el) => el.id == data?.id );
    //         if (matches?.length > 0) {
    //             // replace old one with new, or maybe we should just update all of em...
    //         }
    //     }
    // }
    // state.contacts[is_type].push(data);
  },
  setNameError(state, el) {
    state.errors.name = el;
  },
  setPhoneError(state, el) {
    state.errors.phone = el;
  },
  setEmailError(state, el) {
    state.errors.email = el;
  },
  resetErrors(state) {
    state.errors.name = false;
    state.errors.email = false;
    state.errors.phone = false;
  },
  setRequiredContactsCompleted(state, bool) {
    state.requiredContactsCompleted = bool;
  },
  deleteSavedContactByType(state, is_type) {
    state.savedContacts[is_type] = null;
  },

  // setSavedContactByType(state, { data, is_type }) {
  //     switch (is_type) {
  //         case 'dispatch':
  //             state.dispatchContact = data;
  //         case 'billing':
  //             state.billingContact = data;
  //         case 'claims':
  //             state.claimsContact = data;
  //         case 'afterHours':
  //             state.afterHoursContact = data;
  //         case 'emergency':
  //             state.emergencyContact = data;
  //         case 'owner':
  //             state.ownerContact = data;
  //     }
  //     // if (state.contacts[is_type]?.length > 0) {
  //     //     let matches = [ ...state.contacts[is_type] ];
  //     //     if (matches) {
  //     //         matches = matches.filter((el) => el.id == data?.id );
  //     //         if (matches?.length > 0) {
  //     //             // replace old one with new, or maybe we should just update all of em...
  //     //         }
  //     //     }
  //     // }
  //     // state.contacts[is_type].push(data);
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
